/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfFinancialCategoryDto } from "../models/AjaxResponseOfFinancialCategoryDto";
import type { AjaxResponseOfListOfFinancialCategoryDto } from "../models/AjaxResponseOfListOfFinancialCategoryDto";
import type { AjaxResponseOfPagedResultDtoOfFinancialCategoryForView } from "../models/AjaxResponseOfPagedResultDtoOfFinancialCategoryForView";
import type { FinancialCategoryDto } from "../models/FinancialCategoryDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class FinancialCategoryAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfFinancialCategoryDto
   * @throws ApiError
   */
  public getAllList(): CancelablePromise<AjaxResponseOfListOfFinancialCategoryDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/financial-category/get-all-list",
    });
  }

  /**
   * @returns AjaxResponseOfPagedResultDtoOfFinancialCategoryForView
   * @throws ApiError
   */
  public getAll({
    filter,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfPagedResultDtoOfFinancialCategoryForView> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/financial-category",
      query: {
        filter: filter,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: FinancialCategoryDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/financial-category",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: FinancialCategoryDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/financial-category",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns AjaxResponseOfFinancialCategoryDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfFinancialCategoryDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/financial-category/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/financial-category/{id}",
      path: {
        id: id,
      },
    });
  }
}
